<template>
  <div>
    <div class="d-flex flex-column-fluid">
      <!--begin::Container-->
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-lg-12 col-xl-12">
                <div
                  class="
                    card card-custom
                    gutter-b
                    bg-transparent
                    shadow-none
                    border-0
                  "
                >
                  <div
                    class="
                      card-header
                      align-items-center
                      border-bottom-dark
                      px-0
                    "
                  >
                    <div class="card-title mb-0">
                      <h3 class="card-label mb-0 font-weight-bold text-body">
                        Tickets
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="card card-custom gutter-b bg-white border-0">
                  <div class="card-body">
                    <div>
                      <div class="table-responsive" id="printableTable">
                        <div
                          id="sale_wrapper"
                          class="dataTables_wrapper no-footer"
                        >
                          <div class="dataTables_length" id="sale_length">
                            <label
                              >Mostrar
                              <select
                                name="sale_length"
                                class=""
                                v-model="limit"
                                v-on:change="fetchorders()"
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>
                              registros</label
                            >
                          </div>

                          <div id="sale_filter" class="dataTables_filter">
                            <label
                              >Buscar:<input
                                type="test"
                                class=""
                                placeholder=""
                                v-model="searchParameter"
                                v-on:keyup.enter="fetchorders()"
                            /></label>
                            <button style="padding: 0.375rem 0.75rem !important;" class="btn btn-primary  font-weight-bold mr-1 mb-1" @click="fetchorders()">Buscar</button>
                            <button v-if="this.searchParameter != ''" @click="clearSearch">Borrar busqueda</button>

                          </div>
                          <table
                            id="sale"
                            class="display dataTable no-footer"
                            sale="grid"
                          >
                            <thead class="text-body">
                              <tr sale="row">
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px"
                                >
                                  Ticket id
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px"
                                >
                                  Ticket estado
                                </th>

                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px"
                                >
                                  Total {{getCurrencyTitle()}}
                                </th>

                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px"
                                >
                                  Fecha
                                </th>
                                
                                <th
                                  class="sorting"
                                  tabindex="0"

                                  rowspan="1"
                                  colspan="1"
                                  aria-label="sale: activate to sort column ascending"
                                  style="width: 95.5288px"
                                >
                                  Acción
                                </th>
                              </tr>
                            </thead>
                            <tbody class="kt-table-tbody text-dark">
                              <tr
                                class="kt-table-row kt-table-row-level-0 odd"
                                sale="row"
                                v-for="order in orders"
                                v-bind:key="order.id"
                              >
                                <td>
                                  {{ order.order_id }}
                                </td>
                                <td>
                                  {{ order.order_status }}
                                </td>
                                <td>
                                  {{ order.order_price }}
                                </td>
                                <td>
                                  {{ order.order_date }}
                                </td>
                                <td>
                                  <a
                                    :href="'/admin/order/' + order.order_id"
                                    class="click-edit"
                                    id="click-edit1"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="right"
                                    data-original-title="Check out more demos"
                                    ><i class="fa fa-edit"></i
                                  ></a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <ul class="pagination pagination-sm m-0 float-right">
                            <li
                              v-bind:class="[
                                { disabled: !pagination.prev_page_url },
                              ]"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="fetchorders(pagination.prev_page_url)"
                                >Anterior</a
                              >
                            </li>

                            <li class="disabled">
                              <a class="page-link text-dark" href="#"
                                >pagina {{ pagination.current_page }} de
                                {{ pagination.last_page }}</a
                              >
                            </li>

                            <li
                              v-bind:class="[
                                { disabled: !pagination.next_page_url },
                              ]"
                              class="page-item"
                            >
                              <a
                                class="page-link"
                                href="#"
                                @click="fetchorders(pagination.next_page_url)"
                                >Siguiente</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="row">
        <div class="col-12">
          <div class="card card-custom gutter-b bg-white border-0">
            <div class="card-title mb-0">
              <h3 class="card-label ml-3 mt-3 font-weight-bold text-body">
                Generar reporte de ventas
              </h3>
            </div>
            <div class="card-body">        
              <div>
                <label>Fecha del reporte</label>
                <input type="date" v-model="fechaReporte" name="fechaReporte">
                <label class="ml-3">Usuario</label>
                <select  
                  name="uid"
                  id="uid"
                >
                  <option
                    v-for="usuario in usuarios"
                    :value="usuario.u_id"
                  >
                    {{ usuario.name }} - {{ usuario.email }}
                  </option>
                </select>

                <button class="ml-3 btn btn-primary" @click="generarReporte()">Generar</button>
              </div>
            </div>
          </div>  
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="card card-custom gutter-b bg-white border-0">
            <div class="card-title mb-0">
              <h3 class="card-label ml-3 mt-3 font-weight-bold text-body">
                Generar reporte de ventas
              </h3>
            </div>
            <div class="card-body">        
              <div>
                <label>Fecha de inicio</label>
                <input type="date" v-model="fechaReporteInicio" name="fechaReporteInicio">
              
                <label>Fecha de final</label>
                <input type="date" v-model="fechaReporteFinal" name="fechaReporteFinal">
                <button class="ml-3 btn btn-primary" @click="generarReporteSinDetalle()">Generar Sencillo</button>
                <button class="ml-3 btn btn-primary" @click="generarReporteDetallado()">Generar Detallado</button>
              </div>
            </div>
          </div>  
        </div>
      </div>

    </div>

  </div>


    <div
      class="offcanvas offcanvas-right kt-color-panel p-5 kt_notes_panel"
      v-if="display_form"
      :class="display_form ? 'offcanvas-on' : ''"
    >
      <div
        class="
          offcanvas-header
          d-flex
          align-items-center
          justify-content-between
          pb-3
        "
      >
        <h4 class="font-size-h4 font-weight-bold m-0">Agregar Ticket</h4>
        <a
          href="#"
          class="
            btn btn-sm btn-icon btn-light btn-hover-primary
            kt_notes_panel_close
          "
          v-on:click="display_form = 0"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 16 16"
            class="bi bi-x"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            ></path>
          </svg>
        </a>
      </div>
      <form id="myform">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="text-dark">Nombre </label>
              <input
                type="text"
                name="text"
                v-model="order.name"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('name')"
                v-text="errors.get('name')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Dirección </label>
              <select v-model="order.direction">
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
              <small
                class="form-text text-danger"
                v-if="errors.has('direction')"
                v-text="errors.get('direction')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Código </label>
              <input
                type="text"
                name="text"
                v-model="order.code"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('code')"
                v-text="errors.get('code')"
              ></small>
            </div>
            <div class="form-group">
              <label class="text-dark">Dirección </label>
              <input
                type="text"
                name="text"
                v-model="order.directory"
                class="form-control"
              />
              <small
                class="form-text text-danger"
                v-if="errors.has('directory')"
                v-text="errors.get('directory')"
              ></small>
            </div>
            <div class="form-group">
              <input
                type="checkbox"
                name="text"
                v-model="order.is_default"
                id="is_default"
                class="form-check-input"
              />
              <label class="text-dark" for="is_default">Dirección default </label>
              <small
                class="form-text text-danger"
                v-if="errors.has('is_default')"
                v-text="errors.get('is_default')"
              ></small>
            </div>
          </div>
        </div>
        <button type="button" @click="addUpdatesale()" class="btn btn-primary">
          Agregar
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
export default {
  data() {
    return {
      display_form: 0,
      orders: [],
      searchParameter: "",
      sortBy: "id",
      sortType: "DESC",
      limit: 10,
      fechaReporte: "",
      fechaReporteInicio: "",
      fechaReporteFinal: "",
      error_message: "",
      edit: false,
      actions: false,
      pagination: {},
      request_method: "",
      is_default: "0",
      token: [],
      usuarios: [],
      currency: [],
      errors: new ErrorHandling(),
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },

  methods: {
    generarReporte(){
      const routeData = this.$router.resolve({name: 'reporteVenta', path: '/reporteVenta', query: {fecha: this.fechaReporte, uid: uid.value,}});
      window.open(routeData.href, '_blank');
    },

    generarReporteSinDetalle(){
      this.$parent.loading = true;
        var token = localStorage.getItem("token");
        const config = {     
        responseType: 'blob',   
        headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRF-TOKEN': this.csrf,
            responseType: "blob"

          }
                };
        var responseData = {
          fecha_inicio: this.fechaReporteInicio,
          fecha_fin: this.fechaReporteFinal,
          "_token": this.csrf
        };

        axios.post("/tickets/exportarSinDetalle",responseData,config)
        .then((res) => {
            const anchorElement = document.createElement('a');
            let blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              })

              const url = window.URL.createObjectURL(blob);
              anchorElement.href = url;
              anchorElement.download = "Reporte de tickets";
              anchorElement.click();

              window.URL.revokeObjectURL(url);
              //url = window.URL.createObjectURL(blob);
              //window.open(url);
        })
        .finally(() => (this.$parent.loading = false));
      
      //const routeData = this.$router.resolve({name: 'reporteVenta', path: '/tickets/exportar', query: {fecha: this.fechaReporte, uid: uid.value,}});
      //window.open(routeData.href, '_blank');
    },    
    generarReporteDetallado(){
      this.$parent.loading = true;
        var token = localStorage.getItem("token");
        const config = {     
        responseType: 'blob',   
        headers: {
            Authorization: `Bearer ${token}`,
            'X-CSRF-TOKEN': this.csrf,
            responseType: "blob"

          }
                };
        var responseData = {
          fecha_inicio: this.fechaReporteInicio,
          fecha_fin: this.fechaReporteFinal,
          "_token": this.csrf
        };

        axios.post("/tickets/exportar",responseData,config)
        .then((res) => {
            const anchorElement = document.createElement('a');
            let blob = new Blob([res.data], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              });

              const url = window.URL.createObjectURL(blob);
              anchorElement.href = url;
              anchorElement.download = "Reporte de tickets Detallado";
              anchorElement.click();

              window.URL.revokeObjectURL(url);

        })
        .finally(() => (this.$parent.loading = false));
      
      //const routeData = this.$router.resolve({name: 'reporteVenta', path: '/tickets/exportar', query: {fecha: this.fechaReporte, uid: uid.value,}});
      //window.open(routeData.href, '_blank');
    },    
    fetchCurrency() {
        this.$parent.loading = true;
        var token = localStorage.getItem("token");
        const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        };
        var responseData = {};

        axios
        .get("/api/admin/currency?is_default=1", config)
        .then((res) => {
            if (res.data.status == "Success") {
            this.currency = res.data.data;
            }
        })
        .finally(() => (this.$parent.loading = false));
    },
    fetchorders(page_url) {
      this.$parent.loading = true;
      let vm = this;
      page_url = page_url || "/api/admin/order";
      var arr = page_url.split("?");

      if (arr.length > 1) {
        page_url += "&limit=" + this.limit;
      } else {
        page_url += "?limit=" + this.limit;
      }
      if (this.searchParameter != null) {
        page_url += "&searchParameter=" + this.searchParameter;
      }
      page_url += "&sortBy=" + this.sortBy + "&sortType=" + this.sortType;

      var responseData = {};

      axios
        .get(page_url, this.token)
        .then((res) => {
          this.orders = res.data.data;
          vm.makePagination(res.data.meta, res.data.links);
        })
        .finally(() => (this.$parent.loading = false));
    },

    getCurrencyTitle() {
      return this.currency == null ? "" : "(" + this.currency.title + ")";
    },

    makePagination(meta, links) {
      let pagination = {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };

      this.pagination = pagination;
    },
    fetchUsers() {
      this.$parent.loading = true;
      let page_url = "/api/admin/user";
      //page_url += "?getActiveCountry=1";
      axios
        .get(page_url, this.token)
        .then((res) => {
          this.usuarios = res.data.data;
        })
        .finally(() => (this.$parent.loading = false));
    },
    deleteOrders(id) {
      if (confirm("Are You Sure?")) {
        this.$parent.loading = true;
        axios
          .delete(`/api/admin/order/${id}`, this.token)
          .then((res) => {
            if (res.data.status == "Success") {
              this.$toaster.success(res.data.message);
              this.fetchorders();
            }
          })
          .catch((err) => console.log(err))
          .finally(() => (this.$parent.loading = false));
      }
    },
    clearSearch(){
      this.searchParameter = "",
      this.fetchorders();
    }
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.token = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    this.fetchCurrency();
    this.fetchorders();
    this.fetchUsers();
  },
  props: ["loading"],
};
</script>
